module.exports = __webpack_public_path__ + "assets/img/budapark5-1920.88274a58.webp";